import { render, staticRenderFns } from "./GameProgress.vue?vue&type=template&id=7ca72fde&scoped=true"
import script from "./GameProgress.vue?vue&type=script&lang=ts"
export * from "./GameProgress.vue?vue&type=script&lang=ts"
import style0 from "./GameProgress.vue?vue&type=style&index=0&id=7ca72fde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca72fde",
  null
  
)

export default component.exports